
export default{
    base:{
        username:'用户名',
        password:'密码',
        email:'邮箱',
        newPassword:'新密码',
        confirmPassword:'确认密码',
        signIn:'登录',
        signUp:'注册',
        confirm:'确认',
        confirm2:'确认',
        newPassword:'新密码',
        confirmPassword:'确认密码',
        login:'登录',
        feishuLogin:'飞书登录',
        larkLogin:'Lark登录',
        tip:'提示',
        operateSuccess:'操作成功！',
        cancel:'取消',
        ok:'确认',
        operate:'操作',
        more:'更多',
        save:'保存',
        sync:'同步',
        loading:'加载中...',
        exporting:'正在导出...',
        exportSuccess:'导出成功',
        export:'导出',
        yes:'是的',
        no:'不是',
        YES:'是',
        NO:'否',
        line:'行',
        sorry:'抱歉',
        noPage:'当前页面不存在...',
        shareLink:'复制链接',
        submitting:'提交中...',
        previewFile:'预览文件',
        qrcode:'二维码',
        copyFailed:'复制失败',
        formatError:'格式错误!',
        download:'下载',
        delete:'删除',
        operation:'操作',
        operationRecord:'操作记录',
        email:'邮箱',
        name:'名称',
        moreInfo:'更多信息',
        companyInfo:'公司信息',
        year:'年',
        month:'月',
        week:'周别',
        weeks:'周别',
        beginDate:'开始日期',
        endDate:'结束日期',
        error:'错误',
        update:'更新',

        clearCache:'清除缓存',
        logout:'退出登录',
        search:'查询',
        reset:'重置',
        add:'新增',
        edit:'编辑',
        invalid:'失效',
        detail:'详情',
        input:'请输入',
        select:'请选择',
        selecteDate:'请选择日期',
        pleaseSelectType:'请选择类型',

        saveSuccess:'保存成功',
        addSuccess:'新增成功',
        createSuccess:'创建成功',
        updateSuccess:'更新成功',
        invalidSucess:'失效成功',
        addFail:'新增失败：',
        editSuccess:'编辑成功',
        editFail:'编辑失败：',
        delSuccess:'删除成功',
        delFail:'删除失败：',
        syncSuccess:'同步成功',
        syncFail:'同步失败：',
        notSync:'未同步',
        downloadSuccess:'下载成功！',
        confirmSuccess:'确认成功！',
        delConfirmTip:'是否确认删除?',
        noEmpty:'不能为空!',
        noZero:'不能为0!',
        sendSuccess:'发送成功',
        sending:'发送中...',
        send:'发送',
        assignSuccess:'分配成功',
        selectData:'请选择数据',
        cancelSuccess:'取消成功',
        success:'成功',
        fail:'失败',
        amountIncludeTax:'金额含税',
        discountIncludeTax:'折扣含税',
        uploadImg:'上传图片',
        base:'基础操作',
        cc:'抄送人',

        filter:'筛选',
        notLess0:'不能小于0',
        large:'大',
        medium:'中',
        small:'小',

        open:'展开',
        close:'收起',

        enterEmail:'输入邮箱',
        enterUser:'输入用户',
        enterSomething:'请输入',
        emailReceiveTip:'发送dealer收账清单的邮箱',
        operation:'操作',
        date:'发票日期',
        deleteConfirmTip:'是否确认删除?',
        cancelConfirmTip:'是否确认取消?',
        isConfirmTip:'是否确认?',
        saveTip:'是否确认保存?',
        setting:'设置',

        detail:'车型详情',
        date:'日期',
        confirm2:'确认',
        cancelEdit:'取消编辑',
    },
    login:{
        title:'你好！让我们开始吧',
        subTitle:'登录以继续',
        bottomTitle:'没有账户？',
        create:'创建',
        remmenber:'记住账号',
        fogget:'忘记密码？',
        usernameEmpty:'用户名不能为空！',
        emailEmpty:'邮箱不能为空！',
        passwordEmpty:'密码不能为空！',
        feishuLoginError:'登录异常！错误信息',
        backFeishuLogin:'点击按钮，将重新跳转至飞书登录授权页面',

        completeVeriftyTitle:'请完成安全验证',
        swipeRight:'向右滑动完成验证',
        verificationFailed:"验证失败",
        verificationSuccessful:'验证成功',
        clickMoreOne:'请逐一点击',
        errorPageTip:'请检查您输入的网址是否正确，或点击下面按钮返回订单管理页面。',
        jumpToOrder:'将跳转到订单管理页面',
    },
    signUp:{
        title:'新建账号？',
        subTitle:'注册很容易。只需几步',
        bottomTitle:'已经有帐户？',
        tip:'注册成功！前往登录',
        error_email:'邮箱格式不正确！',
        emailEmpty:'邮箱不能为空！',
        passwordVaildMsg:'密码需由6-10位数字和字母组成',
        password:'密码 (需由6-10位数字和字母组成)',
        emailVaildMsg:'该邮箱已被注册！'
    },
    confirmPwd:{
        title:'忘记密码？',
        subTitle:'重置密码很容易。只需几步',
        bottomTitle:'已经有帐户？',
        editPwd:'密码修改成功',
        vaildPwd:'密码不一致！',
        emailMsgEmpty:'邮箱不能为空',
        newPasswordEmpty:'新密码不能为空！',
        confirmPasswordEmpty:'确认密码不能为空！',
    },
    menu:{
        home:'首页', 
        orderList:'订单管理', 
        prepaidOrderList:'预付款订单管理',
        returnOrder:'退货杂单管理',
        orderApprovalList:'业务订单审批列表',
        B2BShopOrderList:'经销商订单管理(B2B Shop)',
        dealerOpenOrder:'经销商未成交订单',
        preOrderList:'经销商业务订单管理(OOS)',
        invoiceList:'发票管理',
        platformInvoiceList:'平台发票',
        productList:'产品管理', 
        productQuery:'整车库存',
        availabilityEdit:'交付维护',
        availabilityReport:'交付报表',
        eBikeAvailability:'整车交付管理',
        outbounds:'出库订单管理',
        customers:'客户管理',
        customerList:'客户管理', 
        dealerList:'经销商管理',
        saleGoal:'销售目标',
        financial:'财务管理',
        financialReceipts:'财务收账',
        log:'系统日志',
        history:'历史订单',
        errorLog:'报错日志',
        orderRiskVerificationLog:'订单风险验证日志',
        config:'基础配置',
        soSyncConf:'SO同步过滤配置',
        orderSource:'同步订单来源',
        // emailReceive:'经销商逾期邮件配置',
        emailReceive:'邮箱配置',
        countryCodeConfig:'国家代码配置',
        setting:'系统设置', 
        role:'角色权限管理', 
        user:'用户角色管理',
        orderSubList:'订单列表',
        returnExchangeList:'退换货列表',
        addEmail:'邮箱注册管理',
        backfill:'数据补录（本地）',
        creditImport:'退款与红字导入（本地）',
        financialInvoiceImport:'财务发票导入（本地）',
        platformInvoiceImport:'平台发票导入（本地）',
        incomeImport:'收入导入（本地）',
        discountImport:'折扣导入（本地）',
        pdfRerun:'PDF识别重跑（本地）',
        dataCheck:'数据校验（本地）',
        dashboard:'数据看板',
        dataStatistics:'数据统计',
        stockOutList:'出库管理',
        menuManage:'菜单管理',
        dealerGoal:'经销商目标',
        saleFrameGoal:'销售车架目标',
        cash:'现金流',
        accounts:'应付',
        priceList:'同步ERP价目表',
        productPlanList:'产品可用性计划列表',
        taxConfig:'税率配置',
        saleDealerConfig:'销售-经销商配置',
        areaSaleManagerConfig:'区域销售经理配置',
        dealerLevelConfig:'经销商等级配置',
        deliveryDateRangeConfig:'发货配置',
        bomQuery:'整车部件查询',
        kpiDailyReport:'KPI日报表',
        warningList:'出库预警管理',
        signatureList:'发货签收',
        incomeReport:'收入报表',
        incomeCheck:'收入数据检查',
        discountReport:'折扣报表',
        inventoryLock:'库存锁定',
        preSaleOrder:'预售订单',
    },
    order:{
        deliver:'发货申请',
        invoice:'填写发货申请单',
        curStock:'当前库存数量',
        deliverRecord:'发货记录',
        viewLogistics:'物流信息',
        refundRecord:'退款记录',
        downloadInvoice:'下载发票',
        addProduct:'新增订单行',
        syncToERP:'同步订单到ERP',
        delete:'删除',
        cancelSO:'SO取消',
        editOrder:'编辑',
        returnFactory:'返修',

        deliverRecord2:'发货申请',
        refundRecord2:'退款',
        cancelSO2:'取消',
        cancelSORecord2:'SO取消',
        downloadInvoice2:'下载',
        sendInvoice2:'发送',
        viewLogistics2:'物流',
        base:'基础',
        invoice:'发票',
        invoice2:'发票',
        record:'记录',
        changeOrderStatus:'状态',
        cancelOrder:'取消',
        refundOrder:'退款',
        deleteInvoice:'删除',
        createPrepaymentOrder:'创建预付款订单',
        linePrePaidQuantity:'已预付数量',

        finalPayment:'尾款单',
        partialPay:'部分付款',
        pay:'支付',
        refund:'退款',
        returnsAndRefund:'退货退款',
        partialRefund:'部分退款',
        partialReturnsAndRefund:'部分退货退款',
        canceled:'已取消',
        // initial:'初始',
        unship:'未发货',
        plan:'计划发货',
        partialShip:'部分发货',
        shiped:'已发货',
        signedFor:'已签收',
        close:'已关闭',
        obligation:'待付款',
        fail:'失败',
        unknown:'未知',
        partialReturn:'部分退货',
        partialExchange:'部分换货',
        return:'退货',
        exchange:'换货',
        user:'用户',
        dealer:'经销商',
        c2c:'C&C',
        virtual:'虚拟',
        initial:'初始',
        outbound:'已出库',
        unOutbound:'未出库',
        notSalesOrder:'非销售订单',
        uploading:'上传中',

        other:'其他',
        shopify:'Shopify',
        jobrad:'Jobrad',
        bikeExchange:'Bike Exchange',
        amazonSeller:'Amazon Seller',
        decathlon:'Decathlon',
        factoryDirectSales:'Factory Direct Sales',
        amazonVendor:'Amazon Vendor',
        alltricks:'All Tricks',

        deliverTip:'请先选择该订单下需要发货的产品',
        selectWms:'请先选择仓库，查看库存，再发货',
        courierTip:'物流公司、物流单号、发货仓库不能为空！',
        courierTip2:'物流公司、物流链接、发货仓库不能为空！',
        courierTip3:'物流公司、发货仓库不能为空！',
        // quantityTip:'预计发货数量不能大于下单数量!',
        // quantityTip2:'预计发货数量不能为空，且不能为0!',
        // quantityTip3:'预计发货数量与已发货数量之和不能大于下单数量!',
        // quantityTip4:'预计发货数量不能大于下单数量!',
        // quantityTip5:'可用数量不足!',
        quantityTip:'预计发货数量不能大于下单数量!',
        quantityTip2:'预计发货数量不能为空!',
        quantityTip3:'预计发货数量与已发货数量之和不能大于下单数量!',
        quantityTip4:'发货数量不能大于库存锁定数量!',
        quantityTip5:'可用数量不足!',
        quantityTip6:'发货日期不能为空!',
        quantityTip7:'仓库不能为空!',
        quantityTip8:'发货数量不能大于可发货数量!',
        quantityTip9:'整车仓库不一样，不能申请发货!',
         
        orderNumber:'订单编号',
        orderName:'订单编号', //'订单名称',
        confirmedName:'订单确认编号',
        orderSource:'订单来源',
        confirmedName:'订单确认编号',
        orderStatus:'订单状态',
        customerType:'客户类型',
        country:'国家',
        erpNo:'ERP SO No.',

        courierStatus:'物流状态',
        courierType:'物流公司',
        courierNo:'物流单号',
        orderDate:'订单日期',
        deliverQty:'发货数量',
        curQuantity:'预计发货数量',

        deliverDetailTitle:'本次发货产品明细',

        orderAmount:'订单金额',
        orderDiscount:'订单折扣',
        orderTax:'订单扣税',
        InvoiceAmount:'发票金额',
        finalAmount:'最终金额',
        payAmount:'支付金额',
        payAmount3:'支付',
        refundAmount:'退款金额',
        realPayAmount:'实付金额',
        payCurrency:'支付货币',
        deliverStatus:'发货状态',
        customerType:'客户类型',
        orderTimestamp:'订单时间',
        refundTimestamp:'退款时间',
        creditNoteNo:'红字发票号',
        customerEmail:'客户邮箱',
        customerName:'客户名称',
        customerInvoiceName:'客户名称(发票)',
        country:'国家',
        outboundStatus:'出库状态',
        unitCode:'单位',
        erpLineNo:'ERP行号',
        deliveryNumber:'Mes出库单号',

        orderLineNo:'订单行号',
        inventoryCode:'物料编码',
        warehouse:'发货仓库',
        quantity:'下单数量',
        needShipquantity:'需发货数量',
        shipQuantity:'发货中数量',
        shippedQuantity:'已发货数量',
        backQuantity:'退货数量',
        deliveryDate:'发货日期',
        sku:'SKU',
        productName:'产品名称',
        productName2:'名称',
        wms:'发货仓库',
        inventory:'库存',
        amount:'金额',
        discount:'折扣',
        price:'单价',
        depositAmount:'订金金额',
        torque:'扭矩',
        operate:'操作',
        frameShape:'车形',

        logisticsDetail:'物流明细',

        courierLink:'物流链接',
        referenceInventory:'库存数量',
        happenedTime:'物流更新日期',
        
        noCourierInfo:'暂无物流信息',

        create:'创建订单',
        preAmount:'定金金额',
        handleTimestamp:'预计发货时间',
        taxRate:'税率',
        createSuccess:'创建订单成功！',
        customerErpCode:'ERP客户编码',
        baseInfo:'基本信息',
        amountInfo:'金额信息',
        customerInfo:'客户信息',
        edit:'编辑',
        cancel:'取消',
        edit2:'编辑',
        cancel2:'取消',
        delete2:'删除',
        cancelLineSO:'取消SO',
        changeConfirmTip:'是否确认将订单状态改成【支付】？',
        changeConfirmTip2:'是否确认将订单状态改成【取消】？',
        changeConfirmTip3:'是否确认将订单状态改成【退款】？',
        changeConfirmTip4:'是否确认将订单状态改成【待付款】？',
        changeConfirmTip5:'是否确认将订单状态改成【部分支付】？',
        cancelERPSOTip:'请先取消ERP SO',
        syncConfirmTip:'是否确认同步？',
        changeSKUTip:'是否确认修改SKU？',
        viewVersion:'查看版本',
        viewVersion2:'查看版本',
        operator:'操作人',
        sendInvoice:'发送发票',
        sendInvoiceMsg:'是否确认发送发票给客户，客户可下载发票进行预览？',
        sendInvoiceMsg2:'已发送邮件',
        sendInvoiceMsg3:'次，',
        sendInvoiceMsg4:'请确认是否需要再次发送',

        cancelQty:'取消数量',
        cancelConfirmTip:'是否确认取消？',
        cancelStatus:'取消状态',
        partialCanceled:'部分取消',
        canceled:'已取消',
        notCancel:'未取消',
        cancelSORecord:'SO取消记录',
        type:'类型',
        syncStatus:'同步状态',
        schedulingQuantity:'占用数量',
        availableQty:'可用数量',
        versionTime:'修改时间',
        cancelQuantity:'取消数量',

        backNumber:'退货数量',
        backStatus:'退货状态',
        returning:'退货中',
        swaping:'换货中',
        returnSuccessful:'退货成功',
        exchangeSuccessful:'换货成功',
        returned:'退货成功',
        swaped:'换货成功',
        cancelReturn:'取消退货',

        sex:'性别',
        male:'男',
        female:'女',
        unknown:'未知',

        frameNumber:'车架号',
        bikeCount:'整车数量',
        shipDate:'发货日期',
        extraDiscount:'额外折扣',
        payTypeDiscount:'支付折扣',
        payTypeDiscount2:'支付折扣2',
        cargoFreight:'运费',
        cargoFreight2:'运费',
        paymentType:'支付方式',
        payWithDaysDiscountRate:'现金折扣比例',
        paymentTypeDiscount:'支付折扣比例',
        paymentTypeDiscount2:'支付折扣比例2',
        payDay:'账期',
        // cashDiscountRatioDay:'现金折扣比例计算天数',
        langTemplate:'发票语言模板',
        preTaxUnitPrice:'不含税单价',
        preTaxDiscount:'不含税折扣(单台车)',
        preTaxPayAmount:'不含税金额',
        preTaxExtraDiscount:'不含税额外折扣(单台车)',
        afterTaxUnitPrice:'含税单价',
        postTaxDiscount:'含税折扣',
        postTaxPayAmount:'含税金额',
        afterTaxExtraDiscount:'含税额外折扣(单台车)',
        afterTaxDiscount:'含税折扣(单台车)',
        afterTaxPayAmount:'含税支付金额',
        summary:'金额汇总(含税)',
        preTax:'不含税',
        afterTax:'含税',
        preAfterTax:'含税/不含税',
        orderExtraDiscount:'额外折扣',
        payWithin14daysDiscount:'14天内支付的折扣金额',
        payWithin90daysDiscount:'90天内支付的折扣金额',
        unitPrice:'单价',

        orderUse:'订单用途',
        backFlag:'车辆是否归还',
        isReturn:'归还',
        notReturn:'不归还',
        rollOverInventory:'转仓仓库',
        exportOrder:'导出订单',
        exportEBike:'导出订单车辆',
        exportCustomer:'导出订单客户信息',
        exportUnshipOrder:'导出未发货订单',
        exportOrderData:'订单数据',
        exportEBikeData:'订单车辆数据',
        exportCustomerData:'订单客户数据',
        exportUnshipOrderData:'未发货订单数据',

        currentAmount:'当前支付金额',
        refundReasonType:'退款原因类型',
        refundReason:'退款原因',
        payAmount2:'支付金额(含税)',
        refundAmountVaildMsg:'退款金额不能大于支付金额',

        greaterThan0:'需要大于0',
        invoiceAddress:'发票地址',
        sameSKUExists:'存在相同的SKU',
        instruction:'备注',
        reissue:'补寄',
        replenishing:'补寄中',
        reissueTimestamp:'补寄日期',
        reissueInfo:'补寄信息',
        reissueNumber:'补寄单号',
        reissueSuccessful:'补寄成功',
        reissueType:'补寄类型',
        reissueQuantity:'补寄数量',
        swapInventoryCode:'物料编码',
        bom:'Bom物料编码',
        selectProduct:'请添加补寄产品',
        reasonType:'补寄原因类型',
        reason:'补寄原因',
        reissueTimestamp:'补寄发出时间',
        stockQuantity:'库存数量',

        productQuantity:'生产数量',
        productQuantityErrorTip:'生产数量不能大于下单数量',
        createUser:'创建人',

        confirmProduct:'请确认产品信息',
        frameColor:'车架颜色',
        cancelSOConfirmTip:'是否确认取消该行',
        createDate:'创建日期',

        orderType:'订单类型',
        sale:'销售',
        unSale:'非销售',
        notForSale:'非销售',

        customerNumber:'渠道来源编码',
        area:'区域',
        hfCustomerLevel:'客户等级',
        paymentType:'支付方式',
        paymentDay:'账期',

        invoiceNo:'发票号',
        userNote:'用户备注',

        deliveryType:'发货方式',
        deliverConfirmTip1:'该订单未付款，请确认是否已发货？',
        deliverConfirmTip2:'该订单部分付款，请确认是否已发货？',
        riskValidate:"风险验证",
        riskLevel:'风险等级',
        confirmedAsRisk:"确认风险",
        relieveRisks:'解除风险',
        orderRisk:'订单风险',
        riskLevel:'风险等级',
        lowRisk:'低风险',
        mediumRisk:'中风险',
        highRisk:'高风险',
        none:'不可用',
        isValid:'已验证',
        isRelieve:'已解除',
        noValid:'未验证',
        confirmeSuccessful:'确认成功!',
        relieveSuccessful:'解除成功!',
        cancelSOHeadTip:'仅整单cancel才可以重新编辑订单数据，部分 cancel不能编辑订单。',

        logistics:'物流',
        downloadInvoiceMsg:'订单只有在已发货且有车架号的情况下才能开具发票',

        editOrderConfirmTip:'该订单已经同步到ERP，是否确认编辑？',
        editOrderConfirmTip1:'如果确认，请在编辑订单后，到ERP系统进行同步修改。',
        editOrderConfirmTip2:'否则，会影响数据正确性。',
        editOrderConfirmTip3:'请到ERP系统进行同步修改，',

        ECommerceVendor:'E-commerce Vendor',
        preInvoiceNo:'预开发票号',
        redownloadInvoice:'重新下载发票',
        downloadCustomDateInvoice:'生成订单发票',
        downloadInvoiceTip:'如果订单内容已更新，请点击“生成订单发票”重新生成发票内容。',
        invoiceDateTip:'可自定义发票日期',
        customerInfo:'客户信息',
        invoiceInfo:'发票信息',
        reSend:'重新发送',

        orderChannelType:'订单渠道类型',
        invoiceTimestamp:'发票日期',
        shipWeek:'预发货周别',
        shipYear:'预发货年份',

        orderConfirmation:'订单确认书',
        downloadConfirmation2:'下载订单确认书',
        downloadConfirmation:'下载确认书',
        sendConfirmation:'发送确认书',
        reDownloadConfirmation:'重新生成订单确认书',
        sendConfirmationMsg:'您确定要将订单确认书发送给客户吗？客户可以下载订单确认书进行预览',
        downloadConfirmationTip:'如果订单内容已更新，请点击“生成订单确认”重新生成订单确认内容。',
    
        qty:'数量',
        brandName:'品牌名称',
        partName:'零件名称',
        model:'车型',
        modelYear:'上市年份',
        modelYear2:'年份',
        modelModelYear:'车型/上市年份',

        day14Tip:'为鼓励回款，公司对于支付方式为“by invoice”的客户，将给予14天内付款的客户1%的折扣。',
        cancelDate:'订单取消日期',
        refundDate:'订单退款日期',
        lineAmount:'金额(含税)',
        linePrice:'单价',
        lineDepositAmount:'定金',

        lineQuantity:'下单数量',
        lineShipQuantity:'发货中数量',
        lineBackQuantity:'退货数量',
        lineProductQuantity:'生产数量',
        InventoryQty:'库存数量',

        orderLineMaxQtyTip:'每个订单最多只能新增50行',
        deliverOrderLineMaxQtyTip:'一次最多只能选择15行',

        priceTip1:'无法获取该车辆价格，请通过以下方式解决：',
        priceTip2:'【方式1】在OMS系统同步ERP价目表',
        priceTip3:'【方式2】请联系相关人先在ERP维护价目表，然后在OMS系统同步ERP价目表',
        syncNewPrice:'同步最新单价',

        defaultAddress:'默认发货地址',
        invoiceAddress:'发票地址',
        userNote:'用户备注',

        lastValidOrderNo:'该渠道最后一个订单号是: ',
        lastValidOrderNo2:'该渠道暂无订单',
        exceedingMaxQty:'可下单数量为 ',
        exceedingMaxQty2:'，当前已超出!',
        prepaidCustomer:'预付客户',
        quantityNoZero:'金额汇总部分的下单数量不能为0，请检查或重新输入订单行的下单数量！',

        tax:'税率',
        countryCode:'国家编码',
        createTax:'新建税率',

        syncUnitPriceTip:'单价减去折扣不等于支付金额，请检查数据!',
        syncUnitPriceTip2:'已是最新单价',

        recalculateAmount:'重新计算金额',
        totalPaymentDiscount:'总支付折扣',
        totalFreight:'总运费',
        earliestShipTimestamp:'最早发货日期',
        earliestShipDateTip:'如果填写了最早发货日期，则订单的申请发货日期不能早于该日期!',
        shipDateTip:'订单发货日期不能早于最早发货日期!',
        dealerInactiveTip:'该经销商已被禁止订购，请联系我们的销售团队+49（0）8142 2844481或',
        earliestShipDateTip2:'该订单的最早发货日期是',
        earliestShipDateTip3:', 当前发货日期不能早于该时间',
        earliestShipDateTip4:'，所以目前不能申请发货',

        noShip:'当前时间，禁止发货!',
        customerPaymentTypeTip:'客户支付方式是: ',

        orderDateCurMonthTip:'订单只能建在当月，请填写正确的订单日期！',
        preShipmentYearTip:'预发货年份不能小于订单日期年份！',
        earliestShipmentDate:'最早发货日期不能小于订单日期!',
        returnDateTip:'退回日期不能小于发货日期！',
        returnDateTip2:'退回日期不能小于订单日期！',
        planDateTip:'计划发出日期不能小于发货日期！',
        planDateTip2:'计划发出日期不能小于订单日期！',
        refundDateTip:'退款日期不能小于订单日期！',
        reissueDateTip:'补寄发出日期不能小于订单日期！',
        orderNameRuleTip:'订单名称不符合规则，命名规则：支持输入大小写英文字母（不含"O"和"o"）、数字、- 、#，长度为6~50。',
        orderNameRuleTip2:'订单名称不符合规则，命名规则：支持输入大小写英文字母、数字、- 、#，长度为6~50。',

        EBikeOrderName:'整车订单编号：',
        service:'服务',
        serviceOrder:'服务订单',
        ebikeOrder:'E-Bike订单',
        noNeedToShip:'无需发货',
        createServiceOrder:'创建服务订单',
        shipQty:'发货数量',
        bindSku:'整车SKU',
        signTime:'签收时间',
        serviceOrdreLineQtyTip:'投保数量不能大于订单行整车数量',
        serviceCount:'投保数量',
        serviceOrderDateTip:'订单日期需大于订单签收日期14天',

        autoComputeFreight:'运费规则有变更。点击确认，2025-01-15至2025-02-07日创建的订单，将根据新规则自动计算运费。',
        freightConfirm:'运费规则变更',

        orderConfirmMail:'订单确认邮箱',
        emailFormatTip:'邮箱格式不正确！',

        virtual:'虚拟订单',
        c2c:'C&C',
        confirmVirtualOrder:'确认虚拟订单',
        virtualOrder:'这是虚拟订单',
        c2cExtraAmount:'C&C收费',

        secondHandFlag:'是否二手车',
        orderCategory:'订单类别',
        customerObjByPickUpIdTip:'无法获取客户信息，获取【source_id】失败',


        openPosition:'Open Position',
        priceList:'价目表',
        openPositionData:'Open Position Data',
        priceListData:'价目表数据',

        customerNumber:'客户编码',
        orderNumber:'订单号',
        shipmentNotificationNumber:'发货单号',
        invoiceNumber:'发票号',
        invoiceDate:'发票日期',
        dueDate:'逾期日期',
        amountTotal:'总金额',
        amountPaid:'支付金额',
        paid:'支付状态',
        payStatus:'支付状态',

        dealerOrderName:'经销商订单号',
        bike:'整车',
        part:'零件',
        normal:'普通',
    },
    prepaidOrder:{
        createPrePaidOrderSuccess:'创建预付款订单成功!',
        invalidate:'变更为无效',
        invalidateTip:'是否确认要将该预付款订单更改为无效?',
        sendInvoiceTip:'确定要将该预付款订单的发票发送给客户吗?',
        validityStatus:'有效性状态',
        valid:'有效的',
        invalid:'无效的',
        unbind:'解绑',
        unbindTip:'是否确认解绑出库单？',
        createPrepaidOrder:'创建预付款订单',
    },
    preSaleOrder:{
        importConfig:'导入配置',
        dealerName:'经销商',
        paymentType:'支付类型',
        paymentDay:'账期',
        paymentTypeDiscount:'支付折扣率',
        payWithDaysDiscountRate:'现金折扣率',
        taxRate:'税率',
        invoiceAddress:'发票地址',
        shippingAddress:'发货地址',
        country:'国家',
        winterFinancing:'是否冬季折扣',
        paymentPeriod:'账期日期',
        cashDiscountPeriod:'国家折扣账期',
        configImport:'确认导入',
        saveOrder:'保存订单',
        tip1:'请上传文件(.xlsx, .xls)',
        title1:'拆分订单结果',
        availableSKUs:'可用SKUs',
        unavailableSKUs:'不可用SKUs',
        unknownSKUs:'未知SKUs',
        nopriceSKUs:'缺失价目表SKUs',

        availableSKUsOrders:'可用SKUs订单数',
        unavailableSKUsOrders:'不可用SKUs订单数',
        unknownSKUsOrders:'未知SKUs订单数',
        nopriceSKUsOrders:'缺失价目表SKUs订单数',

        orderNo:'订单号',
        bikeQty:'整车数量',
        skuQty:'SKU数量',
        deliveryDateByCustomer:'客户要求交期',
        shippingCostNoTax:'运费',
        taxRate:'税率',
        paymentTypeDiscountAmountNoTax:'支付折扣',
        netAmount:'总价',
        taxAmount:'税额',
        total:'订单金额',
        payWithDaysDiscountAmountInTax:'现金折扣',
        
        sku:'SKU',
        model:'车型',
        quantity:'数量',
        size:'尺寸',
        color:'颜色',
        type:'类型',
        orderType:'订单类型',
        shippingMonth:'发货月份',
        expectedShippingDate:'发货交期 (By Customer)',
        expectedDelivery:'发货交期',

        totalQty:'总数',
        unitPrice:'单价',
        eta:'交期',
        overdue:'超期',

        deliveryInfo:'交付信息',

        category:'类别',
        articleNumber:'Article Number',
        model:'车型',
        description:'描述',
        dealerPrice:'经销商价格',
        totalUnits:'订单金额 (Units)',

        downloadTemplate:'下载模板',
        orderDetail:'订单详情',
        oderNameTip:'这是所创建订单的详细信息。请到“订单”页面查看。',
        saveTip:'该文件已失效。请重新选择文件。',

        discount:'折扣',
        payAmount:'支付金额',
        preDiscountRate:'支付折扣',
    },
    approval:{
        basicInfo:'基础信息',
        approvalRecord:'审批记录',
        deleteFilters:'删除筛选项',
        customerName:'客户名称',
        customerNumber:'客户号',
        orderNumber:'订单号',
        orderAmount:'订单金额',
        quantity:'订单车辆数',
        instanceCode:'流水号',
        initiationDate:'发起日期',
        overdueStatus:'逾期状态',
        businessOrderTimestamp:'订单日期',
        businessOrderAmount:'订单金额',
        customerUnpaidAmount:'客户未付款金额',
        customerCreditQuota:'客户信用额度',
        status:'审批状态',

        history_amount:'历史交易金额',
        customer_unpaid_amount:'未付款',
        maximum_overdue_days:'最长逾期天数',
        overdue_situation :'近三个月付款情况',
        insolvency_index:'破产指数',
        customer_payment:'客户支付方式',
        credit_file:'信用报告上传',
        credit_file2:'信用报告',
        sale_instruction:'备注',

        customer_credit_quota:'客户信用额度',
        fileType:'支持zip、pdf、doc、xlsx类型，上传的文件最大10M',
        days:'天',

        node:'审批节点',
        approver:'审批人',
        results:'审批结果',
        comments:'评论',
        approvalTime:'审批时间',

        detail:'审批详情',
        refuse:'拒绝',
        closed:'已关闭',
        close:'关闭',
        adopt:'通过',
        pending:'审批中',
        rejected:'已拒绝',
        approval:'审批通过',
        approve:'审批',
        finish:'完成',
       
        cancel:'取消',

        approveTip:'是否确认通过?',
        refuseTip:'是否确认拒绝?',
        closeTip:'是否确认关闭?',

        approvalSuccess:'审批成功，订单已通过',
        approvalRefuse:'订单已被拒绝',
        approvalClose:'订单已被关闭',

        nodeCode:'审批节点',
        userName:'审批人',
        statusRes:'审批结果',
        createTimestamp:'审批日期',

        approvalRecord:'审批记录',
        approved:'已审批',
        pendingApproval:'待审批',
        downloading:'下载中...',

        nodeBegin:'审批开始',
        nodeFinance:'财务审批',
        nodeSale:'销售审批',
        nodeCEO:'CEO审批',
        nodeEnd:'审批结束',
        currentNodeCode:'当前处理人',
        ceo:'CEO',
        finance:'财务',
        sale:'销售总监',
    },
    dealerOpenOrder:{
        available:'可处理',
        unavailable:'不可处理',
        sku:'SKU',
        categoryCode:'类别',
        modelYear:'年份',
        model:'车型',
        orderNumber:'订单号',
        customerNumber:'客户编码',
        orderChannelType:'渠道来源',
        orderTimestamp:'订单日期',
        quantity:'数量',
        amount:'金额',
        deliveryBlock:'交付',
        normal:'普通',
        bike:'整车',
        parts:'零件',
        unitPrice:'单价',
        totalAmount:'总金额',
        totalQty:'总数量',
        unshipQty:'未发货数量',
        dealerOpenOrderData:'经销商未成交订单数据',
        exportExcel:'导出Excel',
        exportAllExcel:'导出全部',
        description:'描述',
        erpSoNo:'ERP SO. No.',
        orderStatus:'订单状态',
        shipmentStatus:'发货状态',
        asm:'ASM',
    },
    dealerPreOrder:{
        businessOrderName:'预订单号',
        customerLevel:'客户等级',
        amount:'金额',

        ordered:'下单',
        confirm:'确认',
        cancel:'取消',

        bronze:'青铜',
        silver:'白银',
        gold:'黄金',
        platinum:'铂金', 

        categoryType:'物料类别',
        price:'单价',

        standard:'Standard',
        express:'Express',
        collection:'Collection',

        modelYear:'上市年份',
        modelVersion:'车型',
        confirmStatus:'确认状态',
        frameColor:'颜色',
        frameShape:'车架',
        frameSize:'尺寸',
        orderOperatetype:'订单类型',
        operateWhole:'整车',
        operatePart:'零配件',

        close:'关闭',
        userNote:'用户备注',
        creditValidate:'信用额度验证',
        validateSuccess:'验证通过',
        validateFail:'验证失败',
        closeSuccess:'订单已关闭',
        closeOrderTip:'是否确认关闭订单?',
        verifyConfirm:'核实和确认',
    },
    B2BShopOrder:{
        confirm:'确认',
        verifyStatus:'验证状态',
        unconfirm:'未确认',
        confirmed:'已确认',
        partiallyConfirmed:'部分确认',
    },
    stock:{
        transactionDate:'预计发货日期',
        deliveryDate:'实际发货日期',
        signTime:'签收日期',
        quantity:'数量',
        orderQty:'订单数量',
        shipQty:'实际发货数量',
        plan:'预计',
        real:'实际',
        signFor:'签收',
        signForDate:'签收日期',
        signForSuccess:'签收成功',
        outboundOrderBikeQuantity:'下出库单整车数量',
        unoutboundBikeQuantity:'未出库整车数量',
        outboundBikeQuantity:'已出库整车数量',
        contentTip:'编辑内容不能为空',
        contentTip2:'寄出物流单号或寄出物流链接不能为空！',
        contentTip3:'退回物流单号或退回物流链接不能为空！',
        logistics:'物流信息',
        returnLogistics:'退回物流信息',
        logisticsType:'物流公司',
        logisticsNo:'物流单号',
        logisticsLink:'物流链接',
        deliveryNumber:'Mes出库单号',
        remark:'备注',
        cargoFreight:'运费',
        frameNumber:'车架号',
        confirmFrameNumber:'确认是否修改车架号?',
        po:'外箱号',
        outboundDate:'出库日期',
        brandPartName:'品牌/零件名称',
        brandName:'品牌',
        partName:'零件',
        modelModelYear:'车型/年份',
        modelYear:'年份',
        returnDate:'退回日期', 

        shipment:'发货',
        return:'退货',
        exchange:'换货',
        reissue:'补寄',
        returnFactory:'返修',
        backTimestamp:'退货',
        backRealTimestamp:'收货',
        backDate:'预计退回日期',
        backReceiveDate:'实际退回日期',
        swapTimestampPlan:'预计',
        swapTimestampReal:'实际',
        swapDatePlan:'计划发货日期',
        swapDateReal:'实际发货日期',
        returnStatus:'退货状态',
        swapStatus:'换货状态',
        backQty:'退货数量',
        swapNumber:'换货单号',
        swapQty:'换货数量',
        swapLogistics:'换货物流',
        reissueNumber:'补寄单号',
        reissueStatus:'补寄状态',
        reissueQty:'补寄数量',
        cancelOutbopundConfirmTip:'该操作将会取消出库单下所有产品的出库',
        cancelSwapConfirmTip:'是否确认取消换货单',
        cancelReturnConfirmTip:'是否确认取消退货单',
        cancelReissueConfirmTip:'是否确认取消补寄单',
        cancelOutbound:'取消出库单',
        cancelOutbound2:'取消出库',
        cancelSwap:'取消换货单',
        cancelSwap2:'取消换货',
        cancelReturn:'取消退货单',
        cancelReturn2:'取消退货',
        cancelReissue:'取消补寄单',
        cancelReissue2:'取消补寄',
        shipmentDetail:'发货详情',
        returnDetail:'退货详情',
        exchangeDetail:'换货详情',
        reissueDetail:'补寄详情',
        image:'图片',
        exportShipment:'导出',
        exportShipment2:'导出(FI)',
        exportShipmentData:'出库单数据',
        exportConfirmTip:'是否确认导出?',

        exportReturnData:'退货单数据',
        exportExchangeData:'换货单数据',
        exportReissueData:'补寄单数据',
        exportReturnFactoryData:'返修单数据',

        returningFactory:'返修中',
        returnFactorySuccessful:'返修完成',
        returnFactoryNumber:'返修单号',
        returnFactoryStatus:'返修状态',
        returnFactoryQty:'返修数量',
        returnFactoryDetail:'返修详情',

        bikeCount:'未出库整车数量',
        bikeCount1:'退货中整车数量',
        bikeCount2:'换货中整车数量',
        bikeCount3:'补寄中整车数量',
        bikeCount4:'返修中整车数量',
        bomCount:'未出库Bom数量',
        bomCount1:'退货中Bom数量',
        bomCount2:'换货中Bom数量',
        bomCount3:'补寄中Bom数量',
        asOf:'预计发货时间截止到',
        asOf2:'截止到',

        categoryType:'物料类别',

        planShipStartDate:'预计寄出开始日期',
        planShipEndDate:'预计寄出结束日期',
        realShipStartDate:'实际寄出开始日期',
        realShipEndDate:'实际寄出结束日期',

        planReturnStartDate:'预计退回开始日期',
        planReturnEndDate:'预计退回结束日期',
        realReturnStartDate:'实际退回开始日期',
        realReturnEndDate:'实际退回结束日期',

        swapCourierType:'寄出物流公司',
        swapCourierNo:'寄出物流单号',
        swapCourierLink:'寄出物流链接',
        swapCourierStatus:'寄出物流状态',
        returnCourierType:'退回物流公司',
        returnCourierNo:'退回物流单号',
        returnCourierLink:'退回物流链接',
        returnCourierStatus:'退回物流状态',

        returnLogisticsInfo:'退回物流信息',
        swapLogisticsInfo:'寄出物流信息',
        outScanned:'已扫描',

        deliveryNote:'发货单',
        deliveryNote2:'发货单',

        swapSku:'换货SKU',
        zuExportShipment:'导出Excel',
        sendEmailToZU:'发送出货邮件给ZU',
        sendEmailToZUTip:'输入多个邮箱时，请用逗号分隔',

        addFrameNo:'添加/编辑车架号',
        cancelReturnFactory:'取消返修',
    },
    inventoryLock:{
        sku:'SKU',
        total:'总数',
        inStock:'锁定',
        inTransit:'在途',
        productionPlan:'生产计划',
        availabilityQTY:'可用数量',
        availableQTY:'可用数量',
        lockedQTY:'锁定数量',
        type:'锁定类型',
        inventoryType:'锁定类型',
        warehouse:'仓库',
        totalLockedQTY:'总锁定数量',
        currentLockedQTY:'当前锁定数量',
        shippedQTY:'发货数量',
        estimatedShippingDate:'预计交期',
        estimatedShippingDateByCustomer:'预计交期(由客户)',
        ETA:'ETA',
        quantity:'数量',
        locked:"已锁定",
        view:'查看',
        inventoryLockInfo:'库存锁定信息',
        orderName:'订单号',
        lockStatus:'锁定状态',
        finish:'完成',
        reserved:'保留',
        overdue:'超期',
        refresh:'刷新',
        total2:'总数',
        ship:'发货',
        deliveryDateList:'预计交货日期清单',
        currentQTY:'当前订单锁定数量',
        unlockInventory:'是否库存',
        avaInventoryList:'可以库存列表',
        orderInventoryLockList:'订单库存锁定列表',
        currentLockedQTYTip:'当前锁定数量不能大于可用库存数量!',
        sameData:'同样的数据已经存在!',
        unlockedTip:'已发送的产品数量已存在，且无法解锁!',
        inventoryLockDetail:'库存锁定详情',
        lockInventory:'锁定库存',
        releaseInventory:'释放库存',
        inventoryLockList:'库存锁定列表',
        released:'释放',
        lockTip:'确认是否锁定库存?',
        batchId:'Batch ID',
        releasedTip:'确认是否释放库存?',
        lockSuccessful:'锁定超过!',
        releaseSuccessful:'释放成功!',
        editUnlockTip:'必须先解锁库存锁!',
        shipInStockTip:'请确认整车库存在发货前已锁定.',
        skuOrderQty:'SKU下单数量: ',
        shipInStockTip2:'总的库存锁定数量不能大于SKU下单数量',
        batchId:'Batch ID',
        etaTip:'批次已失效，请重新填写 !'
    },
    warning:{
        wms:'仓库',
        deliveryNumber:'出库单号',
        warningTimestamp:'预警日期',
        warningType:'预警类型',
        warningStatus:'预警状态',
        createDate:'创建日期',
        updateUser:'创建人',
        detail:'详情',
        warning:'警告',
        error:'错误',
        changeToError:'变更为ERROR',
        qty:'数量',
    },
    returnOrder:{
        createReturnOrder:'创建退货杂单',
        selectProduct:'选择产品',
        selectProductMsg:'请选择产品',
        returnDate:'退货时间',
        returnStartDate:'退货开始日期',
        returnEndDate:'退货结束日期',
        courierType:'物流类型',
        courierNo:'物流单号',
        returning:'退货中',
        returnSuccesful:'退货成功',
        backNumber:'退货单号',
    },
    // 平台发票（views/invoice/PlatformInvoiceList.vue）
    platformInvoice:{
        orderNo:'订单号（可填多个，逗号分隔）',
        invoiceNo:'发票号',
        customer:'客户',
        status:'状态',
        valid:'有效',
        invalid:'作废',
        dateFrom:'开票日期起',
        dateTo:'开票日期止',
        export:'导出',
        download:'下载',
        noFile:'没有 PDF',
    },
    // 折扣报表（views/financial/DiscountReport.vue）
    discount:{
        year:'年份（不选为全部）',
        yearLabel:'{year} 年',
        deliveredFrom:'Deliveried Date 起',
        deliveredTo:'Deliveried Date 止',
        po:'PO（可填多个，逗号分隔）',
        invoiceNo:'发票号',
        export:'导出',
        noData:'还没有导入折扣数据',
        customerCode:'Customer ID',
        sku:'SKU',
        new:'新增',
        newTitle:'新增折扣',
        manual:'手工录入',
        deleteConfirm:'删除这条手工录入的折扣？',
        // 新增弹框的字段名，和列表列名一致（列名两种语言都是英文）
        fNo:'NO.',
        fCustomerId:'Customer ID',
        fCustomer:'Customer',
        fPo:'PO',
        fInvoiceDate:'Invoice Date',
        fInvoiceNo:'Invoice No.',
        fSku:'SKU',
        fDescription:'Description',
        fMaterial:'Material category',
        fOutbound:'Outbound No.',
        fDelivered:'Deliveried Date',
        fQty:'Qty',
        fNet:'Net income',
        fTaxRate:'Tax Rate',
        fTaxAmount:'Tax Amount',
        fGross:'Income with VAT',
        fMonth:'Month',
        fFrom:'FROM',
        fTo:'TO',
        fNature:'Nature',
    },
    income:{
        deliveredFrom:'Deliveried Date 起',
        deliveredTo:'Deliveried Date 止',
        po:'PO（可填多个，逗号分隔）',
        invoiceNo:'发票号',
        sku:'SKU',
        customerCode:'Customer ID / 主客户号',
        export:'导出',
        noData:'还没有导入收入数据',
        year:'年份（不选为全部）',
        yearLabel:'{year} 年',
    },
    invoice:{
        create2CInvoice:'创建To C发票',
        create2BInvoice:'创建To B发票',
        download:'下载',
        reDownload:'重新下载',
        reGenerate:'重新生成',
        send:'发送',
        reSend:'重新发送',
        sending:'发送中...',
        delete:'删除',
        invoiceNo:'发票号',
        orderName:'订单号',
        invoiceChildType:'出库单号',
        orderChannelType:'订单渠道类型',
        invoicType:'发票类型',
        orderType:'订单类型',
        invoiceAmount:'发票金额',
        createDate:'发票日期',
        updateDate:'更新日期',
        deliveryNumber:'出库单号',
        outboundStatus:'出库状态',
        frameNumber:'车架号',
        unOutbound:'未出库',
        outbound:'已出库',
        cancelOutbound:'取消出库',
        outScanned:'已扫描',
        quantity:'数量',
        orderDate:'订单日期',
        deliveryDate:'出库日期',
        doubleInvoiceMsg:'这个订单已经有发票了，请不要重复开票。',
        deleteMsg:'是否删除发票 {no}？发票及其 PDF 识别结果会被删除，页面上无法恢复。',
        invalidate:'失效',
        invalidateMsg:'是否将发票 {no} 置为失效？PDF 文件和识别结果保留，页面上无法恢复为有效。',
        sendInvoiceMsg:'是否确认发送发票给客户，客户可下载发票进行预览？',
        reGenerateInvoice:'重新生成发票',
        orderQty:'订单数量',
        shipQty:'发货数量',
        downloadInvoiceTip:'如果订单内容已更新，请点击“确定”重新生成发票内容。',
        invoiceVaildStatus:'发票状态',
        vaild:'有效发票',
        invaild:'预开发票/失效发票',
        platformNo:'平台票',
        payStatus:'付款状态',
        payAmount:'付款金额',
        payAmount2:'支付',
        amount:'金额',
        payAmountTip:'如果与发票金额差值小于0.5欧，则视为全额支付',
        exportInvoice:'导出Excel',
        exportInvoiceData:'发票数据',
        replaceInvoice:'批量替换发票',
        replaceTip1:'文件名必须是「发票号.pdf」，例如 9627504734.pdf',
        replaceTip2:'只替换状态有效的发票。未匹配到、或同一发票号匹配到多条的，会被跳过并在结果中写明原因',
        replaceTip3:'单次上传总大小不超过 10MB（约 7 份），超出请分批上传',
        replaceDryRun:'试跑检查',
        replaceConfirm:'确认替换',
        replaceConfirmTip:'确认后，选中发票的附件将被新文件取代，旧文件会归档留底。是否继续？',
        replaceResult:'处理结果',
        replaceNoFile:'请先选择 PDF 文件',
        replaceFileName:'文件名',
        replaceStatus:'结果',
        replaceMessage:'说明',
        replaceSuccess:'替换完成',
        modifyInvoice:'批量修改发票',
        modifyTip1:'按发票号修改订单号、出库单号、发票日期和金额，不修改发票附件',
        modifyTip2:'请使用标准模板。除发票号外，其余列留空表示该项不修改',
        modifyTip3:'金额列务必是数字格式；改挂订单时，若该发票原本有出库单号则必须填写新的出库单号',
        modifyDryRun:'试跑检查',
        modifyConfirm:'确认修改',
        modifyConfirmTip:'确认后将按文件内容修改发票数据，改前的值会归档留底。是否继续？',
        modifyResult:'处理结果',
        modifyNoFile:'请先选择 Excel 文件',
        modifyChange:'变更内容',
        modifyExport:'导出结果',
        modifySuccess:'修改完成',
        modifyNoChange:'无变化',
        modifyAction:'动作',
        modifyActionModify:'修改',
        modifyActionRestore:'恢复为有效',
        modifyVoided:'作废占位发票',
        modifyCheckExport:'下载检查结果',
        modifyChangeExport:'导出变更记录',
        modifyNoResult:'请先试跑检查',

        normalInvoice:'普通发票',
        prepaidInvoice:'形式发票',
        creditNote:'红字发票',
        selectInvoiceType:'选择发票类型',
        selectInvoiceTypeTip:'请选择发票类型',
        invoiceType:'发票类型',
    },
    plan:{
        importFile:'导入计划',
        exportFile:'导出计划',
        downloadTemplate:'下载计划数据模板',
        quantity:'数量',
        recordDate:'计划交期',
        recordYear:'年份',
        recordWeek:'周别',
        inventoryCode:'物料编码',
        remark:'备注',
        createTimestamp:'创建日期',
        productName:'产品名称',
        hasSku:'已存在相同的SKU',
        planData:'产品计划数据',
        importSuccess:'导入成功!',
        importing:'导入中 ...',
        importFail:'导入失败',
        downloadTemplateSuccess:'下载模板成功!',
        deleteTip:'是否确认删除?',
        sourcePo:'PO号',
        factory:'工厂',
        recordMonth:'月份',
        splitOrder:'拆分',
        inStockQuantity:'库存数量',
        deliveryDate:'交付日期',
        selectSKU:'请选择正确的SKU',
        inTransitQuantity:'在途数量',
        recordDate:'交期',

        versionCode:'版本编码',
        splitOrder:'拆分订单',
        inStockQuantity:'库存数量',
        inTransitQuantity:'在途数量',
        recordDate:'日期',
        record:'历史记录',
        maisachEdit:'Maisach交付计划',
        quantityTip:'The sum of the quantity of rows cannot exceed the quantity of the original SKU',
        quantityTip2:'The quantity of rows cannot be less than the rest quantity of rows',
        quantityTip3:'The quantity of rows cannot be less than the in stock quantity of rows',
        quantityTip4:'The quantity of rows cannot be less than the in transit quantity of rows',
        quantityTip6:'The sum of the quantity of rows does not equal the quantity of headers. Please check !',
        
        restQtyTip:'The sum of the rest quantity of rows cannot exceed the rest quantity of headers',
        restQtyTip2:'The sum of the rest quantity of rows does not equal the rest quantity of headers. Please check !',

        inStockQtyTip:'The sum of the in stock quantity of rows cannot exceed the in stock quantity of headers',
        inStockQtyTip2:'The sum of the stock quantity of rows does not equal the stock quantity of headers. Please check !',

        inTransitQtyTip:'The sum of the in transit quantity of rows cannot exceed the in transit quantity of headers',
        inTransitQtyTip2:'The sum of the transit quantity of rows does not equal the transit quantity of headers. Please check !',

        quantityTip5:'The in transit quantity of rows cannot be less than the in stock quantity of rows',
    },
    returnExchange:{
        returnAndExchange:'退货 & 换货',
        returnAndExchange2:'退货 & 换货 & 补寄',
        returnExchange:'退货/换货',
        returnExchangeRecord:'退货记录',
        returnExchangeRecord2:'退货/换货',
        exchangeRecord:'换货记录',
        reissueRecord:'补寄记录',
        type:'类型',
        status:'状态',
        erpNo:'ERP编号',
        erpLineNo:'ERP行号',
        source:'来源',
        customerErpCode:'ERP客户编码',
        quantity:'数量',
        discount:'折扣',
        sku:'SKU',
        productName:'产品名称',
        inventoryCode:'ERP物料编码',
        backTimestamp:'退货日期',
        backRealTimestamp:'退货实际收到日期',
        backReasonType:'退换货原因类型',
        backReason:'退换货原因',
        ibsVerificationType:'IBS验证方案类型',
        ibsVerificationPlan:'IBS验证方案描述',
        customerName:'客户名称',
        backNumber:'退货单号',
        swapNumber:'换货单号',
        swapInventoryCode2:'整车换货物料编码',
        swapInventory:'换货仓库',
        swapQuantity:'换货数量',
        backQuantity:'退货数量',
        returnedQuantity:'已退货数量',
        swapCourierNo:'物流单号',
        swapCourierType:'物流公司',
        swapTimestampPlan:'换货计划发出时间',
        swapTimestampReal:'换货实际发出时间',
        swapReasonType:'换货原因类型',
        swapReason:'换货原因',
        courierNo:'物流单号',
        courierType:'物流公司',
        return:'退货',
        exchange:'换货',
        backCourierNo:'退货物流单号',
        backCourierType:'退货物流公司',
        backCourierStatus:'退货物流状态',
        exchangeCourierNo:'换货物流单号',
        exchangeCourierType:'换货物流公司',
        exchangeCourierStatus:'换货物流状态',

        returnFactoryInfo:'发货信息',
        returnFactoryReasonType:'返修原因类型',
        returnFactoryReason:'返修原因',
        backTimestamp:'退回日期',
        returnFactoryQty:'返修数量',
        returningFactoryQty:'返修中数量',
        returningFactory:'返修中',
        returnFactorySuccessful:'返修完成',
        returnFactoryTimestampPlan:'计划发出时间',
        returnFactoryCourierNo:'物流单号',
        returnFactoryCourierType:'物流公司',
        returnFactoryTimestampPlan2:'计划发货日期',
        returnFactoryTimestampReal:'实际发货日期',
        returnFactoryCourierNo2:'发货物流单号',
        returnFactoryCourierType2:'发货物流公司',
        returnFactoryCourierStatus:'发货物流状态',
        selectReturnFactoryProduct:'请选择返修产品',
        returnFactoryRecord:'返修记录',
        returnFactoryNumber:'返修单号',
        returnFactoryInventoryCode:'返修物料编码',
        exceedingReturnFactoryQty:'超出可返修数量',

        initial:'初始',
        returning:'退货中',
        exchangeProgress:'换货中',
        returnSuccessful:'退货成功',
        exchangeSuccessful:'换货成功',

        baseInfo:'基础信息',
        returnInfo:'退货信息',
        exchangeInfo:'换货信息',
        orderLineInfo:'订单行信息',
        bomCategory:'Bom类别',
        bom2:'Bom换货物料编码',
        bom:'Bom',
        bike:'整车',
        swapType:'换货类型',
        warehouse:'仓库',
        inventoryRemark:'通用物料备注',
        swapInventoryCode:'换货物料编码',
        swapInventory:'换货仓库',
        swapQuantity:'换货数量',
        exceedingQuantity:'超出可退数量！',
        exceedingDiscount:'超出订单折扣金额，请重新填写！',
        seeFile:'查看附件',
        selectProduct:'请选择退货产品',
        imgLimit:'上传图片不能超过5M！',
        imgLimit2:'图片格式不正确，请上传.jpg/.jpeg文件！',
        uploadDesc:'最多上传3张图片，单张图片不能超过5M，暂时仅支持 .jpg/.jpeg 格式图片',
        uploadFail:'上传图片失败！',
        courierStatus:'物流状态',

        deliveryDate:'发货日期',
    },
    product:{
        sku:'SKU',
        inventoryCode:'物料编码',
        chineseName:'产品名称(中文)',
        englishName:'产品名称',
        germanName:'产品名称(德文)',
        franceName:'产品名称(法文)',
        torque:'扭矩',
        inventory:'库存',
        frame:'车架',
        createDate:'创建日期',
        model_year:'上市年份',
        model:'车型',
        frameShape:'车架',
        frameSize:'尺寸',
        frameColor:'颜色',
        unitWeight:'重量',
        weightUomCode:'重量单位',
        hfVersion:'版本',

        addProduct:'新增产品',
        editProduct:'编辑产品',
        skuTip:'SKU不能为空！',
        inventoryCodeTip:'物料编码不能为空！',
        englishNameTip:'产品名称(英文)不能为空！',
        torqueTip:'扭矩不能为空！',
        frameTip:'车架不能为空！',

        sync:'同步',
        syncTip:'点击同步，更新产品信息到历史订单',
        warehouse:'仓库',
        delConfirmTip:'是否确认删除？',

        categoryName:'类型名称',
        inventoryItemStatusCode:'状态',
        syncERPToOrder:'ERP同步至订单',
        success:'成功',
        fail:'失败',
        notSync:'未同步',
        schedulingQuantity:'计划出库数量',


        torqueSizeColorWeight:'扭矩/车架尺寸/颜色/重量',
        modelYearModel:'上市年份/车型',

        exportFile:"导出Excel",
        productData:"产品数据",
        brandName:'品牌名称',
        partName:'零件名称',
        model:'车型',
        modelYear:'上市年份',
        stockSum:'总汇总',
        warehouseInventory:'仓库库存',
        schedulingQty:'占用数量',
        schedulingTotalQty:'占用总数',
        availabilityQty:'可用库存数',
        trekking7:'Trekking 7 MY24',
        mountain7:'Mountain 7 MY24',
        trekking7Carbon:'Mountain 7 Carbon MY24',
        trekking7MY23:'Trekking 7 MY23',
        ebikeInventory:'整车库存数据',
        ebikeInventorySummary:'整车库存汇总数据',
        resetTableFilter:'重置筛选条件',

        syncERPToOrderTip:'当前车辆BOM未完全同步，请点击【OK】，进行BOM同步。',

        version:'版本',
        zu:'ZU',
        hepha:'Maisach',
        ToBeProduced:'待生产',
        centralWarehouse:'中央仓',
        TTL:'TTL',
        backOrder:'延期订单',
        modelSummary:'汇总',
        inventoryAge:'库龄',

        toBeDelivered:'应发未发',
        deliveryPlan:'计划发',
        supply:'交付',
        endOfMonthInventory:'月底库存',
        yearEndUnshippable:'年终无法发货',
        initialInventory:'期初库存',
        stock:'Stock, Finished bike in GermanyAuto updated from mail',
        itemCode:'Item Code',
        maisach:'Maisach',
        cwh:'CWH',
        frameSize2:'车架尺寸',
        frameType2:'车架类型',
        frameShape2:'车架类型',
        frameColor2:'车架颜色',
        transit:'Transit',
        Jan:'1月',
        Feb:'2月',
        Mar:'3月',
        Apr:'4月',
        May:'5月',
        Jun:'6月',
        Jul:'7月',
        Aug:'8月',
        Sep:'9月',
        Oct:'10月',
        Nov:'11月',
        Dec:'12月',

        availabilityReportData:'订单交付报表数据',
        endWeekTip:'结束周不能小于起始周！',

        active:'激活',
        inActive:'未激活',
        activeStatus:'激活状态',

        placeOrder:'下单',
        cancelPlaceOrder:'取消下单',
        quantity:'数量',
        expectETADate:'期望交期',

        finishedPacking:'ZU Finished Packing',
    },
    customer:{
        customerName:'名称(OMS维护)',
        customerName2:'名称2',
        customerType:'类型',
        customerEmail:'邮箱',
        customerPhone:'电话',
        customerCountry:'国家',
        customerState:'州',
        customerCity:'城市',
        customerAddr:'地址',
        createDate:'创建日期',
        updateDate:'更新日期',
        zip:'邮编',
        billingAddress:'发票地址',
        addressType:'地址类型',
        defaultAddress:'默认地址',
        customerAddr2:'地址2',
        invoiceAddress:'发票地址',
        source:'客户来源(ERP维护)',
        customerErpCode:'ERP客户编码',
        contactName:'公司名称/客户名称',
        contactName2:'客户名称2',
        contactName3:'公司名称/客户名称',
        contactNameNew:'客户名称(OMS Maintenance)',

        user:'用户',
        dealer:'经销商',
        addCustomer:'新建客户',
        editCustomer:'编辑客户基本信息',
        editAddressCustomer:'编辑地址信息',
        syncERPChannels:'同步ERP订单来源',

        sex:'性别',
        male:'男',
        female:'女',
        unknown:'未知',

        companyAddress:'公司地址',
        storeAddress:'店铺地址',
        baseInfo:'基本信息',
        addressInfo:'默认地址信息',
        addressInfo2:'发票地址信息',
        customerEmailFormatError:'邮箱格式不正确！',
        orderConfirmMailFormatError:'订单确认邮箱格式不正确！',

        addCustomerAddress:'新增客户地址',
        differentAddrTip:'发票地址与默认地址不一样',
        firstAddress:'设为首选地址',
        firstAddress2:'首选地址',

        emailServiceFlag:'提供邮箱',

        addLocation:'新增/编辑 B2B Location',
        addPickUpLocation:'新增C&C自提点',
        editLocation:'编辑Location',
        editPickUpLocation:'编辑C&C自提点',
        locationName:'Location名称',
        pickUplocationName:'C&C自提点名称',
        shippingAddress:'发货地址',
        invoiceAddress:'发票地址',
        baseAddress:'地址',
        firstName:'名字',
        lastName:'姓',
        country:'国家',
        city:'城市',
        zip:'邮编',
        eabledFlag:'启用状态',
        contactForB2BShopLogin:'B2B店铺登录联系人',
        firstNameTip:'B2B店铺登录联系人请修复所选客户地址信息，然后添加新的B2B店铺经销商位置信息。',
        
        editCustomerAddressTip:'编辑客户地址',
        editErpCodeTip:'分配子级ERP客户编码',
        dealerErpCode:'子级ERP客户编码',
        enterERPCode:'请输入',
        subErpCodeTip:'格式错误！正确格式：ODE0001-XXXX，XXXX：由3至4位数字或大写字母组成',
        subErpCodeTip2:'正确格式示例：ODE0001-XXXX，XXXX：由3至4位数字或大写字母组成',
        deleteSubERPCodeTip:'删除子级ERP客户编码',
        deleteLineTip:'删除客户地址',

        locationCount:'Location数量',
        ID:'ID',
    },
    dealer:{
        companyName:'公司名称',
        contactPerson:'联系人',
        street:'街道',
        houseNumber:'门牌号',
        zip:'邮编',
        location:'位置',
        country:'国家',
        city:'城市',
        phone:'电话',
        mobile:'移动电话',
        email:'邮箱',
        website:'网站',
        storeAddress:'店铺店址',
        deliveryAddress:'收货地址',
        salesAreaApprox:'销售面积',
        branches:'分支',
        branchesReamrk:'分支备注',
        serviceWorkshop:'是否服务车间',
        foundation:'成立年份',
        portfolio:'投资TOP品牌',
        copySuccessFul:'复制成功!',
        copyTip:'链接有效期为7天，请提醒经销商及时填信息!',
        erpCode:'ERP编码',
        selectSource:'请选择渠道来源',
        qrcode:'生成二维码',
        syncErpCode:'同步ERP Code',
        reEnter:'重新录入',
        contractSigned:'合同是否签署',

        storeHouseNumber:'店铺门牌号',
        storeZip:'店铺邮编',
        storeCity:'店铺城市',
        storePhone:'店铺手机号',
        storeEmail:'店铺邮箱',
        deliveryHouseNumber:'收货门牌号',
        deliveryZip:'收货邮编',
        deliveryCity:'收货城市',
        deliveryPhone:'收货手机号',
        deliveryEmail:'收货邮箱',

        copyLinkTipTitle:"请提醒经销商",
        btnTip:'1. 链接有效期为7天， 请在有效期内打开链接填写信息。',
        btnTip2:'2. 表单提交成功后，链接也会立即失效。',
        qrcodeTip:'截图分享给经销商，扫码填写表单',
        qrcodeTip2:'二维码有效期为7天',

        setLevel:'评级',
        setDealerLevel:'设置经销商等级',
        erpAutoCode:'ERP Auto Code',
        dealerLevel:'经销商等级',
        level:'等级',
        bronze:'青铜',
        silver:'白银',
        gold:'黄金',
        platinum:'铂金',   

        storeInfo:'店铺信息',
        deliveryInfo:'发货信息',
        otherInfo:'其他信息',
        
        exportDealer:'导出经销商数据',
        paymentType:'支付类型',

        saleManager:'区域销售管理员:',
        isActive:'是否活跃:',
        isActive2:'是否活跃',
        testCenter:'测试中心:',
        serviceCenter:'服务中心:',
        saleManager2:'区域销售经理',
        isActive2:'是否活跃',
        testCenter2:'测试中心',
        serviceCenter2:'服务中心',
        inactive:'不活跃',
        active:'活跃',
        editOtherDealerTip:'请至少设置一项数据!',
        

        commitment:'承诺:',
        customerClassification:'客户分类:',
        financialInformation:'财务信息:',
        year:'预测年份:',
        estimate:'预测销量:',
        commitment2:'承诺',
        customerClassification2:'客户分类',
        financialInformation2:'财务信息',
        year2:'预测年份',
        estimate2:'预测销量',
        low:'低',
        middle:'中',
        high:'高',
        dzbNumber:'DZB编号',
        bico:'BICO',
        shopName:'商店名称',
        potential:'潜力:',
        potential2:'潜力',
        becomeDealer:'注册经销商',

        selectLevelTip:'请选择等级！',
        salesNote:'备注',
        paymentDay:'支付天数',
    },
    kpiDailyReport:{
        item:'ITEM',
        orders:'ORDERS',
        delievered:'DELIEVERED(Confirmed By Customer)',
        cancelled:'CANCELLED',
        shipOut:'SHIP OUT',
        mtd:'MTD',
        ytd:'YTD',
        dailyShipmentData:'Daily Shipment Data',
        NOVEMBER:'NOVEMBER',
        orderDetailExport:'导出订单销量',
        erpShipExport:'导出ERP发货数据',
        mesShipExport:'导出MES发货数据',
        dateTip:'此页面数据均为德国时区',
    },
    saleGoal:{
        country:'国家',
        countryCode:'国家代码',
        year:'年份',
        goal:'目标',
        createGoal:'新建目标',
        goalSaleNumber:'目标销量',
        orderChannelType:'订单渠道类型',
        goalType:'目标类型',
        productType:'产品类型',
        productModelYear:'车型',
        month:'月份',
        year:'年份',

        monthGoalNumber:'各月份目标销量',
        yearSummary:'年度销量汇总',
        b2c:'B2C',
        b2b:'B2B',
        c2c:'C&C',
        sales:'SALES',
        bike:'BIKE',
        all:'全部',
        my23:'MY23',
        my24:'MY24',

        Jan:'一月',
        Feb:'二月',
        March:'三月',
        April:'四月',
        May:'五月',
        June:'六月',
        July:'七月',
        Aug:'八月',
        Sep:'九月',
        Oct:'十月',
        Nov:'十一月',
        Dec:'十二月',

        inputGoalSaleNumber:'请输入目标销量'
    },
    financial:{
        orderStartDate:'订单开始日期',
        orderEndDate:'订单结束日期',
        invoiceStartDate:'发票开始日期',
        invoiceEndDate:'发票结束日期',
        updateStartDate:'执行开始日期',
        updateEndDate:'执行结束日期',

        invoiceTimestamp:'发票日期',
        financeCheckTime:'执行日期',

        updateOrderStatus:'更新订单状态',
        updatePaymentDate:'更新付款日期',
        payTimestamp:'付款日期',

        year:'年份',
        month:'月份',
        recordTimestamp:'日期',
        amountIn:'入款',
        amountOut:'出款',
        amountTotal:'现金流合计',
        enterCashFlow:'录入现金流',
        account:'应付',
        enterAccount:'录入应付',

        priceListName:'价目表名称',
        syncERPPrice:'同步ERP价目表',
        selectCustomer:'选择渠道来源',

        syncTip:'如果渠道没有同步，需要先同步渠道',

        createLevel:'创建等级', 
        level:'等级',
        exportPriceData:'导出数据',

        overdueList:'逾期清单',
        SEPACollection:'SEPA收款',
        salesName:'销售人员',
        customer:'客户',
        overdueDays:'逾期天数',
        level:'等级',
        invoiceNumber:'发票号',
        updateTimestamp:'更新日期',
        realPayAmount:'实际付款',
        confirmExecutionStatusTip:'确认执行状态',
        executionStatus:'执行状态',
        executed:'已执行',
        unexecute:'未执行',
        confirmDate:'财务执行日期',
        financeConfirmTime:'执行日期',
        signDate:'签收日期',
        logisticType:'物流公司',
        shipSignTemplates:'发货签收模板',
        returnSignTemplates:'退货签收模板',
        downloadSignTemplate:'下载导入模板',
        importData:'导入',
        selectFile:'选择文件',

        signType:'签收类型',
        shipSign:'发货签收',
        returnSign:'退货签收',
    },
    log:{
        orderNo:'订单编号',
        orderName:'订单编号',
        sku:'SKU',
        source:'订单来源',
        inventoryCode:'物料编码',
        message:'报错描述',
        status:'状态',
        createDate:'创建日期',
        updateDate:'更新日期',
        syncType:'类别',
        syncTimestamp:'同步日期',

        success:'成功',
        error:'错误',

        model:'模块',
        type:'类别',
        handleData:'风险验证',
        createTimestamp:'操作日期',
        updateUser:'操作人',

        isValid:'已验证',
        isRelieve:'已解除',
        noValid:'未验证',
    },
    config:{
        vatNo:'增值税编号',
        enable:'是否启用',
        enable2:'启用',
        disable:'禁用',
        customerType:'客户类型',
        dealerOverdueEmail:'邮箱',
        recipientEmail:'收件人邮箱',
        CCRecipientEmail:'抄送人邮箱',
        dealerOverdueEmailConfig:'经销商逾期',
        recipientEmailConfig:'KPI日报收件人',
        CCRecipientEmailConfig:'KPI日报抄送人',
        inventoryRecipientEmailConfig:'库存收件人',
        saleEmailConfig:'信用额度审批失败接收人',
        inventoryWeekTo:'库存周报收件人',
        inventoryWeekCC:'库存周报抄送人',
        saleName:'销售',
        customerCode:'渠道来源编码',
        create:'新建',
        creditLevel:'信用等级',
        status:'状态',
        cooperate:'合作',
        invalid:'失效',
        reason:'原因',
        dateRange:'日期区间',
        ccEmail:'抄送人邮箱',
        internalEmail:'内部电子邮件',
        externalEmail:'外部电子邮件',
        inventoryWeeklyReport:'库存周报收件人',
        inventoryWeeklyReportBCC:'库存周报抄送人',
        payDiscount:'支付折扣',
        cashDiscount:'现金折扣',
        freight:'运费',
        type:'类型',
        discountFreight:'折扣/运费',
        eu_flag:'是否欧盟国',
        lang:'语言模板',
        updateTip:'请输入折扣或运费',
        setDiscountRate:'设置折扣比例',
        discountRate:'折扣比例',
    },
    dataBoard:{
        dataStatistics:'数据统计',
        vehicleSales:'整车销量',
        factoryShipmentVolume:'工厂出货量',
        orderQuantity:'订单总数',
        bikeQuantity:'整车数量',
        returnQuantity:'整车退货数量',
        cancelQuantity:'整车取消数量',
        shipmentQuantity:'整车发货数量',
        timelyDeliveryRate:'及时交付率',
        outboundBike:'已出库整车',
        paidButUnshippedBike:'已付款未发货整车',
        unpaidBike:'未付款整车',
        fullRefundBike:'全额退款整车',
        pendingPayBike:'未付款未发货整车',
        overdueAndUnpaidBike:'超期未付款未发货整车',
        dataStatistics:'数据统计',
        paymentStatistics:'付款统计',
        confirm:'确定',
        planShipDate:'预计发货日期',
        realShipDate:'实际发货日期',
        overdueDay:'超期15天',
        category:'产品类别',
        within3:'3天内',
        within7:'7天内',
        over7:'超过7天',
        totalEBike:'车辆总数',
        past7days:'默认展示过去7天的数据',
        deliveryRateDetails:'及时交付率明细',
        unscheduledOrder:'未排单'
    },
    setting:{
        menu:'菜单页面',
        role:'角色',
        user:'用户',
        btnAuth:'权限',
        addButton:'新增按钮',
        saveSetting:'保存设置',
        assignRole:'分配角色',
        menuName:'菜单名称',
        addMenu:'新增菜单',
        saveMenuSetting:'保存',

        menuType:'类型',
        btnName:'按钮名称',
        menuParent:'所属菜单父级',
        menuIndex:'所属菜单序号',
        menuCategory:'新增项类别',
        component:'组件',
        saveSettingMsg:'是否确认保存？',
        assignRoleMsg:'请选择角色',
        assignUserMsg:'请选择用户',

        email:'邮箱',
        emailMsg:'邮箱不能为空！',
        emailFormat:'邮箱格式不正确！',

        countryCode:'国家编码',
        countryLocal:'国家本地化名称',
        inputMsg:'请输入信息',

        loginMsg:'保存成功，请用户退出后重新登录',
        loginMsg2:'分配角色成功，请用户退出后重新登录',
        loginMsg3:'删除角色成功，请用户退出后重新登录',

        menuName:'菜单名称',
        menuUrl:'菜单路由',
        menuParent:'父级菜单',
        parentMenuIndex:'父级菜单索引',
        menuIndex:'菜单索引',
        menuAuth:'菜单权限',
        rootMenu:'根菜单',
        edit:'编辑',
        delete:'删除',
        countryCodeEditMsg:"国家本地化名称，车架号，物流三个字段是用于开票本地化设置",

        order:{
            createOrder:'创建订单',
            shippingApply:'发货申请',
            shoppingRecord:'发货记录',
            viewsLogistics:'查看物流',
            refundRecord:'退款记录',
            downloadInvoice:'下载发票',
            addOrderLines:'添加订单行',
            syncToERP:'同步到ERP',
            deleteOrder:'删除订单',
            paid:'支付',
            sendInvoice:'发送发票',
            viewVersion:'查看订单行版本',
            editLine:'编辑订单行',
            deleteLine:'删除订单行',
            cancelSO:'取消SO',
            cancelSORecord:'取消SO记录',
            returnExchange:'退换货',
            returnExchangeRecord:'退换货记录',
            returnFactoryRecord:'返修记录',
            reissueRecord:'补寄记录',
            cancelLineSO:'取消行SO',
            editOrder:'编辑订单',
            partialPay:'部分付款',
            returnFactory:'返修',
            deleteInvoice:'删除发票',
            preInvoiceNo:'预开发票号',

            obligation:'待付款',
            cancelOrder:'取消',
            refundOrder:'退款',
            riskValidate:'风险验证',

            exportEBike:'导出订单',
            exportOrder:'导出订单车辆',
            exportCustomer:'导出订单客户',

            sendConfirmation:'发送确实书',
            downloadConfirmation:'下载确认书',
            reGenerateConfirmation:'生成订单确认书',
            viewAmountDetail:'查看金额明细',
            syncNewPrice:'同步最新单价',

            editPayTypeDiscount:'编辑支付折扣',
            createPrepaymentOrder:'创建预付款订单',

            recalculateAmount:'重新计算金额',
            copy:'复制',
            removeLine:'移除订单行',

            createServiceOrder:'创建服务订单',
        },
        prepaidOrder:{
            invalidate:'变更为无效',
            deliver:'申请发货',
            downloadInvoice:'下载发票',
            unbind:'解绑',
        },
        B2BShopOrder:{
            confirm:'确认',
        },
        dealerOpenOrder:{
            exportExcel:'导出excel',
        },
        product:{
            syncERPToOrder:'ERP同步至订单',
            exportProduct:'导出Excel',
            exportProductQuery:'导出整车库存',
            editPlan:'编辑计划交期',
            exportPlanFile:"导出计划列表",
            exportReportFile:'导出交付报表',
            splitOrder:'拆分订单',
            maisachEdit:'编辑Maisach库存',
            placeOrder:'下单',
            confirmPlaceOrder:'确认下单',
        },
        customer:{
            syncERPCustomer:'同步ERP客户',
            addCustomer:'新增客户',
            editCustomer:'编辑客户',
            deleteCustomer:'删除客户',
            addCustomerAddress:'新增客户地址',
            editCustomerAddress:'编辑客户地址',
            deleteCustomerAddress:'删除客户地址',
            addLocation:'新增/编辑 B2B location',
            editLocation:'编辑 B2B location',
            editPickUpLocation:'编辑C&C自提点',
            saveLocation:'保存 B2B location',
            savePickUpLocation:'保存C&C自提点',
            editErpCode:'分配子级ERP Code',
            deleteSubERPCode:'删除子级ERP Code',
        },
        invoice:{
            replaceInvoice:'批量替换发票',
            modifyInvoice:'批量修改发票',
            create2CInvoice:'创建2C发票',
            create2BInvoice:'创建2B发票',
            downloadInvoice:'下载发票',
            reGenerateInvoice:'重新生成发票',
            sendInvoice:'发送发票',
            deleteInvoice:'删除发票',
            invalidInvoice:'失效发票',
            exportInvoice:'导出发票',
            editPayAmount:'编辑付款金额',
        },
        dashboard:{
            exportFile:'导出订单明细',
            erpShipExport:'导出ERP发货数据',
            mesShipExport:'导出MES发货数据',
        },
        error:{

        },
        channelMap:{
            syncERPChannels:'同步来源'
        },
        config:{
            add:'新增',
            edit:'编辑',
            delete:'删除',
            deleteEmail:'删除邮箱',
            syncERPChannels:'同步来源',
            addRecipientEmail:'新增收件人邮箱',
            addCCRecipientEmail:'新增抄送人邮箱',
            addInventoryRecipientEmail:'新增库存收件人邮箱',
            addSaleEmail:'新增销售邮箱',
            addInventoryWeekEmail:'新增库存周报邮箱',
            deleteRecipientEmail:'删除收件人邮箱',
            deleteCCRecipientEmail:'删除抄送人邮箱',
            deleteInventoryRecipientEmail:'删除库存收件人邮箱',
            deleteSaleEmail:'删除销售邮箱',
            deleteInventoryWeekEmail:'删除库存周报邮箱',
            addInventoryWeeklyReportEmail:'新增库存周报外部收件人邮箱',
            deleteInventoryWeeklyReportEmail:'删除库存周报外部收件人邮箱',
            addInventoryWeeklyReportCCEmail:'新增库存周报外部抄送人邮箱',
            deleteInventoryWeeklyReportCCEmail:'删除库存周报外部抄送人邮箱',
            createSaleDealer:'新增销售-经销商',
            deleteSaleDealer:'删除销售-经销商',
            addAreaSaleManager:'新增区域销售经理',
            deleteAreaSaleManager:'删除区域销售经理',
            createShipDateRange:'新建发货日期区间',
            editShipDateRange:'编辑发货日期区间',
            deleteShipDateRange:'删除发货日期区间',
            setDiscountRate:'设置折扣比例',
        },
        sysSetting:{
            addButton:'新增按钮',
            saveSetting:'保存设置',
            assignRole:'分配角色',
            addEmail:'新增邮箱',
            deleteEmail:'删除邮箱'
        },
        stock:{
            signFor:'签收',
            edit:'编辑',
            detail:'详情',
            download:'下载出库发送单',
            send:'发送出库发送单',
            cancel:'取消出库',
            cancelReturn:'取消退货',
            cancelSwap:'取消换货',
            cancelReissue:'取消补寄',
            downloadReissue:'下载补寄发送单',
            sendReissue:'发送补寄发送单',
            exportShipment:'导出出库单',
            exportShipmentFD:'导出出库单（F.D）',
            zuExportShipment:"ZU导出出库单",
            sendEmailToZU:'发送出货邮件给ZU',
            exportReturn:'导出退货单',
            exportExchange:'导出换货单',
            exportReissue:'导出补寄单',
            exportReturnFactory:'导出返修单',
        },
        approval:{
            closeApproval:'关闭审核',
            approve:'审批',
            detail:'审批详情',
        },
        dealer:{
            shareLink:'分享链接',
            syncErpCode:'同步erp code',
            edit:'编辑',
            preview:'预览文件',
            setLevel:'经销商评级',
            detail:'详情',
            reEnter:'重新录入',
            verifyConfirm:'核实和确认',
            exportDealer:'导出经销商信息',
            becomeDealer:'注册经销商',
        },
        saleGoal:{
            createDealerGoal:'新建经销商目标',
            editDealerGoal:'编辑经销商目标',
            createSaleGoal:'新建车架销售目标',
            editSaleGoal:'编辑车架销售目标',
        },
        financial:{
            updateOrderStatus:'更新订单状态',
            createManualDiscount:'保存新增折扣（折扣报表）',
            updatePaymentDate:'更新付款日期',
            enterCashFlow:'录入现金流',
            editCashFlow:'编辑现金流',
            enterPayable:'录入应付',
            editPayable:'编辑应付',
            syncERPPrice:'同步ERP价目表',
            createTax:'创建税率',
            editTax:'编辑税率',
            exportPriceData:'导出数据',
            exportPriceData2:'订单渠道来源价目表数据',
            editExecuted:'编辑SEPA执行状态',
            downloadSignTemplate:'下载签收模板',
            importData:'导入签收数据',
        },
        inventoryLock:{
            inventoryLockDetail:'库存锁定详情',
            lockInventory:'锁定库存',
            releaseInventory:'释放库存',
            viewLockList:'查看订单行库存锁定',
            editLock:'编辑',
            viewLock:'查看',
            addLockLine:'新增锁定行',
            editLockLine:'不编辑锁定行',
            unlockInventory:'释放库存',
            deleteLockLine:'删除锁定行',
        },
        returnOrder:{
            createReturnOrder:'创建退货杂单',
        },
        plan:{
            addPlan:'新增计划',
            editPlan:'编辑计划',
            deletePlan:'删除计划',
            importFile:'导入计划',
            exportFile:'导出计划',
            downloadTemplate:'下载计划模板',
        },
        warning:{
            changeToError:'变更为ERROR'
        }
    },
}